export default "__VITE_ASSET__D7uwQwm2__"